export const MILLISECONDS_PER_MINUTE = 60 * 1000;
export const MILLISECONDS_PER_HOUR = MILLISECONDS_PER_MINUTE * 60;
export const MILLISECONDS_PER_DAY = MILLISECONDS_PER_HOUR * 24;
export const MILLISECONDS_PER_WEEK = MILLISECONDS_PER_DAY * 7;
export const MILLISECONDS_PER_MONTH = MILLISECONDS_PER_DAY * 30;
export const MILLISECONDS_PER_QUARTER = MILLISECONDS_PER_DAY * 90;
export const MILLISECONDS_PER_YEAR = MILLISECONDS_PER_DAY * 365;

export const getMilliSecondsStartToday = () => new Date().setHours(0, 0, 0);
